<template>
  <DetailList>
    <DetailListHeader title="Figures" />
    <NovenaryDetailListItem title="1st" :figureIndex="1" />
    <NovenaryDetailListItem title="2nd" :figureIndex="2" />
    <NovenaryDetailListItem title="3rd" :figureIndex="3" />
    <NovenaryDetailListItem title="4th" :figureIndex="4" />
    <NovenaryDetailListItem title="5th" :figureIndex="5" />
    <NovenaryDetailListItem title="6th" :figureIndex="6" />
    <NovenaryDetailListItem title="Ternion" :figureIndex="7" />
    <NovenaryDetailListItem title="Sum (32-48)" :alt="sum" />

    <DetailListHeader title="Accordance" />
    <NovenaryDetailListItem title="4th to 6th" :alt="supFourthToSixth" />
    <NovenaryDetailListItem title="5th to 6th" :alt="supFifthToSixth" />

    <DetailListHeader title="Documentation" />
    <div>
      <a
        :style="{ color: getTheme.fore }"
        href="https://minorfracture.blog/2024/01/23/foundations-of-nonastrological-geomancy/"
        >Novenary Guide</a
      >
    </div>
  </DetailList>
</template>

<script>
import { mapGetters } from "vuex";
import DetailList from "./DetailList";
import DetailListHeader from "./DetailListHeader";
import NovenaryDetailListItem from "./NovenaryDetailListItem";
import compare from "../utils/compare";

export default {
  components: { DetailList, DetailListHeader, NovenaryDetailListItem },
  name: "NovenaryList",

  computed: {
    ...mapGetters(["getTheme"]),
    sum() {
      return `${this.$store.getters.getNovenarySum}`;
    },
    supFourthToSixth() {
      return compare.isSupporting(
        this.$store.getters.getNovenaryFigureById(4),
        this.$store.getters.getNovenaryFigureById(6)
      );
    },
    supFifthToSixth() {
      return compare.isSupporting(
        this.$store.getters.getNovenaryFigureById(5),
        this.$store.getters.getNovenaryFigureById(6)
      );
    }
  }
};
</script>

<style scoped lang="scss">
a {
  font-size: 1.2rem;
}

a:hover {
  text-decoration: none;
}
</style>
